import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=c86aa69a"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=c86aa69a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c86aa69a')) {
      api.createRecord('c86aa69a', component.options)
    } else {
      api.reload('c86aa69a', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=c86aa69a", function () {
      api.rerender('c86aa69a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Tickets/detail.vue"
export default component.exports